require('es6-promise').polyfill();
import axios from 'axios';
import Utilities from './utilities';

export default {
  listCategories (module_id, cb_success, cb_failure) {
    axios.get(Utilities.apiURL() + 'category/list/' + module_id)
      .then(function (response) {
        cb_success(response.data.data.categories);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  },
  listProducts (module_id, category_id, sort_order, cb_success, cb_failure) {
    let category_string = '';
    if (category_id !== '') {
      category_string = '&category_id=' + category_id;
    }

    let sort_order_string = '';
    if (sort_order !== '') {
      sort_order_string = '&sort_order=' + sort_order;
    }

    axios.get(Utilities.apiURL() + 'product/' + module_id + '?' + category_string + sort_order_string)
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  },
  infoProduct (module_id, product_id, cb_success, cb_failure) {
    axios.get(Utilities.apiURL() + 'product/' + module_id + '/' + product_id)
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  },
};



// WEBPACK FOOTER //
// ./src/api/product.js